/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useMemo } from 'react';
// material
import { SectionGroupV2 } from 'material/expandablesection/v2'
import Space from 'material/space/space';
import { Tip } from '@insticator/insticator-ui/dist/material';
import { SingleSelectDropDown, InlineMessage, Link } from '@insticator/insticator-ui'
// styles
import injectSheet from 'react-jss'
import styles from './language_styles'
import { languages } from 'utils/consts/language';


const languageMap = (name) => {
  return languages.filter(language => language.id === name)?.pop() || languages[0]
}

/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: SITE THEME SECTION : LANGUAGE ~~~~~~~~~~ ========== */
const Language = injectSheet(styles)((props) => {

  const { siteTheme, setSiteThemeConfig } = props

  const handleLanguageOptionChange = opt => {
    setSiteThemeConfig('language', opt.value)
  }

  const selectedLanguage = useMemo(() => 
    <Space>
      <img alt={siteTheme.language} src={languageMap(siteTheme.language || 'EN').icon}  />
      <span>{languageMap(siteTheme.language).name}</span>
    </Space>
  , [siteTheme.language])

  return (
    <SectionGroupV2 
      klass={`language ${props.classes.language}`}
      title={'Language'} 
      description={'Choose your preferred language based on your site’s audience.'}
      indented
      direction={'column'}
    >
      <Space alignItems={'center'}>
        <SingleSelectDropDown 
          name={selectedLanguage}
          searchable={false} 
          onSelect={handleLanguageOptionChange}
          items={languages}
        />
        <Tip space={'left'} icon={'question-circle'} content={'The selected language will not be applied to user comments.'} />
      </Space>
      <InlineMessage 
        variant={'neutral'}
        display={true}
        icon={'exclamation-circle'}
        message={
        <span>
          <strong>Note: </strong>
          We also offer an API to dynamically change the language of this unit by passing a query string parameter.{' '}
           <Tip 
            content={`
              This is useful in the event you are determining, on the fly, what language to show a user or allowing the user themselves to select a preferred language to view content in. 
              In that scenario you can simply call our API and pass a language parameter and our unit will automatically update the text to reflect the selection
            `}
            label={''}
          />
        </span>
        }
        close={false}
      />
    </SectionGroupV2>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Language;